import Course from "@pathwright/ui/src/components/library/Course"
import { type ResourceFragment } from "@pathwright/graphql-client/src/generated"
import { type ComponentType, type PropsWithChildren } from "react"
import * as PathUI from "../ui/PathUI"

type PreviewPathResourceProps = {
  pathItem: {
    linked_resource?: Pick<ResourceFragment, "id" | "name" | "image"> | null
  }
  layout?: "grid" | "list"
}

// These legacy JavaScript components do not declare their complete props.
const CourseCard = Course as ComponentType<{
  course: PreviewPathResourceProps["pathItem"]["linked_resource"]
  layout?: PreviewPathResourceProps["layout"]
}>
const ResourceContainer = PathUI.PathResourceContainer as ComponentType<
  PropsWithChildren<Pick<PreviewPathResourceProps, "layout">>
>

const PreviewPathResource = ({
  pathItem,
  layout
}: PreviewPathResourceProps) => {
  return (
    <ResourceContainer layout={layout}>
      <CourseCard course={pathItem.linked_resource} layout={layout} />
    </ResourceContainer>
  )
}

PreviewPathResource.displayName = "PreviewPathResource"

export default PreviewPathResource
